import { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";
import { useNavigate } from "react-router-dom";
import idBook from "../../../../Images/IDBook.png";
import idCard from "../../../../Images/IDCard.png";
import passport from "../../../../Images/Passport.png";
import serviceId from "../../../../Images/ServiceIdExample.png";
import { useSessionStore } from "../../../../Stores/SessionStore";
import FileUploadBlock from "../../../Registration/Steps/FileUploadBlock";
import Loader from "../../../../Images/loader.svg";

export default function RICAModal(props) {
    const store = useSessionStore();
    const navigate = useNavigate();

    const steps = {
        Examples: 1,
        IDDocument: 2,
        ServiceID: 3,
        SavingFiles: 4,
        Complete: 5,
        ThankYouMessage: 6,
        ErrorMessage: 7
    }

    const [step, setStep] = useState(steps.Examples);
    const [documents, setDocuments] = useState({IDDocument: null, ServiceIDDocument: null});
    const [errorMessage, setErrorMessage] = useState("");
    const [retry, setRetry] = useState(false);

    function handleIDUploaded(file, fileName) {
		setDocuments({...documents, IDDocument: { Content: file, FileName: fileName }});
	}

    async function handleServiceIDUploaded(file, fileName) {
		setDocuments({...documents, ServiceIDDocument: { Content: file, FileName: fileName }});
	}

    async function uploadDocuments() {
        if (documents.IDDocument && documents.ServiceIDDocument) {
            
            setStep(steps.SavingFiles);
            var result = await store.CustomersService.SubmitDocuments(store.CustomerDetails.Customer.Id, documents);
            
            if(result && result.Success) {
                setRetry(false);
                if (!store.CustomerDetails.Address.ExistingRICACustomer) {
                    let introActivated = await activateIntroPackage();
                    if (introActivated.Success) setStep(steps.Complete);
                } else {
                    setStep(steps.Complete);
                }

            } else if (result && result.Success === false){
                setErrorMessage("There was an error saving your documents. Please try again.");
                setRetry(true);
                clearDocuments();
            } else if (!result){
                setErrorMessage("There was a communication error when saving your documents. Please try again.");
                setRetry(true);
                clearDocuments();
            }
        }
    }

    async function clearDocuments() {

        let result = await store.CustomersService.ClearDocuments(store.CustomerDetails.Customer.Id);

        if(result && result.Success) {
            setStep(steps.ErrorMessage);
        } else {
            setStep(steps.ErrorMessage);
        }
    }

    async function activateIntroPackage()
    {
        let result = await store.CustomersService.ActivateIntroPackage();

        if (!result || !result.Success) {            
            setErrorMessage(result.Message ? result.Message : "There was an error activating your free trial. Please contact Zing Fibre support ");
            setStep(steps.ErrorMessage);
        }

        return result;
    }

    function getStep() {
        switch(step) {
            case steps.Examples:
                return <StepOne nextStep={ () => setStep(steps.IDDocument) } />;
            case steps.IDDocument:
                return <StepTwo nextStep={ () => setStep(steps.ServiceID) } documents={documents} handleUpload={handleIDUploaded} />;
            case steps.ServiceID:
                return <StepThree nextStep={ () => uploadDocuments() } documents={documents} handleUpload={handleServiceIDUploaded} />;
            case steps.SavingFiles:
                return <StepFour />;
            case steps.Complete:
                return <StepFive nextStep={ () => navigate("/Portal/Recharge") } existingCustomer={store.CustomerDetails.Address.ExistingRICACustomer} activateIntroPackage={ activateIntroPackage }/>;
            case steps.ThankYouMessage:
                return <ThankYouMessage onOKClicked={ () => props.onOKClicked() }/>;
            case steps.ErrorMessage:
                return <ErrorMessage onOKClicked={ () => props.onOKClicked() } onRetryClicked={() => {uploadDocuments()}} errorMessage={errorMessage} retry={retry}/>;
            default:
                return <StepOne nextStep={ () => setStep(steps.IDDocument) } />;
        }
    }

	return 	<Modal show={ props.show } size={"lg"}>
				<Modal.Header>
					<h3>
						RICA
					</h3>
				</Modal.Header>
				{ getStep() }
			</Modal>
}

function StepOne({ nextStep }) {
    return (
        <>
            <Modal.Body>
                <p className="text-center">You are required to RICA before your service can be activated. Please see examples of ID documentation that will be accepted.</p>
                <Row>
					<Col className="d-flex justify-content-center">
						<img src={ idCard } style={{ height: "150px" }}></img>
					</Col>
					<Col className="d-flex justify-content-center">
						<img src={ idBook } style={{ height: "150px" }}></img>
					</Col>
					<Col className="d-flex justify-content-center">
						<img src={ passport } style={{ height: "150px" }}></img>
					</Col>
				</Row>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row className="d-flex justify-content-center">
                    <Col className="col-3">
                        <GradientButton title="Next" variant="greenYellow" onClick={nextStep} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}

function StepTwo({ nextStep, documents, handleUpload }) {
    const navigate = useNavigate();

    return (
        <>
            <Modal.Body>
                <p className="text-center">Please upload the ID document for the ID number used in the initial sign up. If this is not the same ID please sign up as a different user by clicking the button below.</p>
                <Row className="text-center">
                    <Col xs={12} md={12} xl={12} className=" mb-3">
                        <FileUploadBlock
                            filename={ (documents?.IDDocument ? documents.IDDocument.FileName : null ) }
                            file={ (documents?.IDDocument ? documents.IDDocument.Content : null) }
                            onFileChanged={ handleUpload }
                            name="IdBook"
                            description="ID Book or Card / Foreign Passport"
                        />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row>
                    <Col className="col-12 col-lg-6 mb-2 mb-lg-0 text-center">
                        <GradientButton title="Upload ID" variant="greenYellow" disabled={!documents.IDDocument} onClick={documents.IDDocument ? nextStep : undefined} />
                    </Col>
                    <Col className="col-12 col-lg-6 text-center">
                        <GradientButton title="Sign up as a different user" variant="yellowOrange" onClick={() => navigate("/Register/welcome")} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}

function StepThree({ nextStep, documents, handleUpload }) {

    return (
        <>
            <Modal.Body>
                <p className="text-center">Let's confirm you are purchasing for the correct home. Please confirm the service ID by uploading a picture of the sticker on the wall by your router.</p>
                <Row>
					<Col className="d-flex justify-content-center pb-4">
						<img src={ serviceId } style={{ height: "150px" }}></img>
					</Col>
				</Row>
                <Row className="text-center">
                    <Col xs={12} md={12} xl={12} className=" mb-3">
                    <FileUploadBlock
                        filename={ (documents?.ServiceIDDocument ? documents.IDDocument.FileName : null ) }
                        file={ (documents?.ServiceIDDocument ? documents.IDDocument.Content : null) }
                        onFileChanged={ handleUpload }
                        name="ServiceID"
                        description="Service ID Picture"
                    />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row className="d-flex justify-content-center">
                    <Col className="col-6">
                        <GradientButton title="Upload Service ID Picture" variant="greenYellow" disabled={!documents.ServiceIDDocument} onClick={documents.ServiceIDDocument ? nextStep : undefined} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}

function StepFour() {
    return (
        <>
            <Modal.Body>
                <div>
					<Row className="mb-5 text-center">
						<Col>
							<h4 className="mb-4">One moment. We're saving your files...</h4>
						</Col>
					</Row>
					<Row className="text-center">
						<Col>
							<img src={Loader}></img>
						</Col>
					</Row>
				</div>
            </Modal.Body>
        </>
    )
}

function StepFive({ nextStep, existingCustomer }) {
    return (
        <>
            <Modal.Body>
                <p className="text-center">{`Thank you for uploading your documents and confirming your Service ID. We are reviewing the documents. ${existingCustomer ? "" : "Your Free Trial has been activated. "}Welcome to Zing Fibre!`}</p>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row className="d-flex justify-content-center">
                    <Col className="col-7">
                    <GradientButton title={existingCustomer ? "Continue with purchase" : "Ok"} variant="greenYellow" onClick={nextStep} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}

function ErrorMessage({ onOKClicked, errorMessage, retry, onRetryClicked}) {
    return (
        <>
            <Modal.Body>
                <p className="text-center text-danger">{errorMessage}</p>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row className="d-flex justify-content-center">
                    <Col className="col-6">
                    <GradientButton title={retry ? "Retry" : "Ok"} variant="greenYellow" onClick={retry ? onRetryClicked : onOKClicked} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}

function ThankYouMessage({ onOKClicked}) {
    return (
        <>
            <Modal.Body>
                <p className="text-center">Thank you for uploading your documents and confirming your Service ID. We are reviewing the documents. Your Free Trial has been activated. Welcome to Zing Fibre!</p>
            </Modal.Body>
            <Modal.Footer className="d-block">
                <Row className="d-flex justify-content-center">
                    <Col className="col-6">
                    <GradientButton title="Ok" variant="greenYellow" onClick={onOKClicked} />
                    </Col>
                </Row>
            </Modal.Footer>
        </>
    )
}